module.exports = __webpack_public_path__ + "static/media/galerija_2021 (11).928ce46a.jpg";